import React from "react";
import { Box, Card, Stack, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import StatusComponent from "../../../stories/StatusComponent/StatusComponent";
import { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import Nodata from "../../../pages/Nodata/Nodata";

import TextareaAutosize from "@mui/material/TextareaAutosize";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Grid } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
// import FormControl from '@mui/material/FormControl';
import Select from "@mui/material/Select";
import MuiSelect from "@mui/material/Select";
import { Chip, Checkbox } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import LocationContextEdit from "./LocationContextEdit";

import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";

import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import fileDownload from "js-file-download";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import { getOrgType } from "../../../utils/Token";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    marginBottom: "20px",
  },
}));

export default function Roles({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  VIEWMODE,
  setHasLocationData,
  PQCLIENTID,
  PqStatusID,
  PqClientName,
  IsMultiple,
  LocationSectionReset
}) {
  const params = new URLSearchParams(window.location.search);
  const PQID = params?.get("pqid");
  const [response, setResponse] = useState([]);
  const [refresh, setRefresh] = React.useState(true);
  const [loading, setLoading] = useState(false);
  // const { reset } = useForm();

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        BaseURL.baseUrl +
        "Prequalification/SectionOrSubSectionDetails?pqId=" +
        PQID +
        "&sectionId=" +
        Secid +
        "&subSectionTypeCondition=" +
        SubSectionTypeCondition +
        "&sectionType=" +
        SectionType +
        "&subSectionId=" +
        SubId
      )
      .then((resp) => {
        setResponse(resp?.data?.data);
        setLoading(false);
        if (resp?.data?.data?.length > 0) {
          setHasLocationData(true);
        } else {
          setHasLocationData(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [refresh]);

  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [Deletesite, setDeletesite] = useState("");
  const Deletedialogbox = (e) => {
    setDeletesite(e);
    setDeleteDialog(true);
  };
  const DeleteSite = () => {
    handleDelete();
    setDeleteDialog(false);
  };
  const DeletedialogboxClose = () => {
    setDeleteDialog(false);
  };

  async function handleDelete(e) {
    const res = await axios.post(
      "Prequalification/DeletePQSiteSync?pqId=" +
      PQID +
      "&pqSiteId=" +
      Deletesite
    );
    if (res?.data?.responseMessage == "TrainingPaymentDone") {
      toast.error(
        "Can't delete the site as training payment is done for the site.",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    } else if (res?.data?.responseMessage == "AdditionalPaymentDone") {
      toast.error("Can't delete the site as additional payment is done for the site.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (res?.data?.responseMessage == "Success") {
      toast.success(res?.data?.responseMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (res?.data?.responseMessage == "Error while deleting location") {
      toast.error("Can't delete the site. Please contact the technical support team.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    } else {
      toast.error(res?.data?.responseMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    LocationSectionReset();
    setRefresh(!refresh);
  }
  const NotDisPqStatusListForDelete = [16, 13, 10, 14, 32, 33, 4, 8, 9, 5, 26, 7, 15, 31];
  const NotDisPqStatusListForEditandAdd = [16, 13, 10, 14, 32, 33, 4, 8, 9, 5, 26, 31];

  const IMPORTANTNOTICECLIENTIDS = [1302, 6563, 8652, 1458, 8754, 2, 6601];

  const IsmultipleClientAddbuttionShow = [-1, 3, 7, 15, 9, 26, 5, 14, 31, 32, 33, 4, 16, 13, 8, 35];
  const IsmultipleClientEddbuttionShow = [3, 15, 35];

  const [open, setOpen] = useState(false);
  // const [open1, setOpen1] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme?.breakpoints?.down("md"));

  const [id, setID] = useState("");
  const [clientBuUnitID, setClientBuUnitID] = useState("");
  const [clientBuUnitSiteID, setClientBuUnitSiteID] = useState("");
  const [cliId, setCliId] = useState("");
  const [pqSitesId, setPqSitesId] = useState("");
  const [comment, setComment] = useState("");
  const [isERITemplate, setIsERITemplate] = useState(false);

  const handleClickOpen = (num, r) => {
    setID(num);
    setClientBuUnitID(r?.clientBusinessUnitId);
    setClientBuUnitSiteID(r?.clientBusinessUnitSiteID);
    setCliId(r?.clientId);
    setPqSitesId(r?.prequalificationSitesId);
    setComment(r?.comment);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const Open = () => {
    setOpen(true);
  };

  const [PqClients, setPqClients] = useState([]);
  const [FirstClient, setFirstClient] = useState("");

  useEffect(() => {
    axios
      .get("Prequalification/GetClientsAndTemplateTypeForLocations?pqId=" + PQID + "&clientId=" + PQCLIENTID)
      .then((resp) => {

        setIsERITemplate(resp?.data?.data?.isERITemplate)
        setPqClients(resp?.data?.data?.clients?.filter((r) => r?.key != PQCLIENTID));
        setFirstClient(resp?.data?.data?.clients[0]?.key);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const groupedData = response?.reduce((acc, curr) => {
    const clientKey = curr?.clientName;
    const buKey = curr?.businessUnitName;
    if (!acc[clientKey]) {
      acc[clientKey] = {};
    }
    if (!acc[clientKey][buKey]) {
      acc[clientKey][buKey] = [];
    }
    acc[clientKey][buKey]?.push(curr);
    return acc;
  }, {});

  const [expanded, setExpanded] = React.useState(false);
  const ChangeExpanded = () => {
    setExpanded(expanded);
  };

  const handleDownload = (e) => {
    axios
      .get(
        BaseURL.baseUrl +
        "Documents/DownloadDocument?idAsFileName=" +
        e?.documentId,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        if (res?.data?.type == "application/json") {
          toast.error("File not found", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          const file = new Blob([res?.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow?.document?.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

          //fileDownload(res?.data, e.documentName);
        }

      });
  };
  return (
    <Card sx={{ backgroundColor: "#fff" }}>
      <Button
        className="mx-2"
        size="large"
        variant="contained"
        sx={{ textTransform: "capitalize", padding: "12px", float: "right" }}
        hidden={getOrgType() == "Client" ? true : getOrgType() == "Vendor" && IsMultiple == true ? !(IsmultipleClientAddbuttionShow?.includes(PqStatusID)) : (getOrgType() == "Vendor" ? NotDisPqStatusListForEditandAdd?.includes(PqStatusID) : !VIEWMODE)}
        onClick={() => handleClickOpen(1, "")}
      >
        + Add New
      </Button>
      <br />
      <br />
      <ToastContainer />
      <Dialog
        open={DeleteDialog}
        keepMounted
        onClose={DeletedialogboxClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> Are are sure you want delete this site?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This means the selected site is going to be lost forever.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={DeletedialogboxClose}>DisAgree</Button>
          <Button onClick={DeleteSite}>Agree</Button>
        </DialogActions>
      </Dialog>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }}>
              {id == 1 ? "Add Location(s)/Project(s)" : "Edit Location(s)/Project(s)"}
            </span>
            <br></br>
          </DialogTitle>
          <LocationContextEdit
            PQID={PQID}
            SEC={Secid}
            SUB={SubId}
            SECTIONTYPE={SectionType}
            SUBSECTYPCON={SubSectionTypeCondition}
            PqClients={PqClients}
            REFRESH={setRefresh}
            REFREE={!refresh}
            Close={handleClose}
            SetOpen={Open}
            ID={id}
            ClientBuUnitID={clientBuUnitID}
            ClientBuUnitSiteID={clientBuUnitSiteID}
            CliId={cliId}
            FirstClient={FirstClient}
            Comments={comment}
            PqSitesId={pqSitesId}
            isERITemplate={isERITemplate}
            LocationSectionReset={LocationSectionReset}
          />
        </DialogContent>
      </Dialog>
      {response?.length > 0 ? (
        Object.entries(groupedData)?.map(([clientName, clientData]) => (
          <>
            <div key={clientName}>
              <Accordion onChange={ChangeExpanded} sx={{ marginTop: "10px" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  sx={{ backgroundColor: "#F2F4F7" }}
                >
                  <Typography
                    sx={{
                      flexShrink: 0,
                      fontSize: "600",
                      color: "#667085",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {" "}
                    {clientName == "null" ? "Global Locations" : clientName}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0px" }}>
                  <Box sx={{ backgroundColor: "#f8f9fa" }}>
                    <TableContainer
                      component={Paper}
                      key={"ss" + clientName}
                      sx={{ borderBottom: 0 }}
                    >
                      <Table aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell>Comments </StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell>&nbsp;</StyledTableCell>
                            <StyledTableCell>&nbsp;</StyledTableCell>
                          </TableRow>
                        </TableHead>

                        {Object.entries(clientData)?.map(([buName, buData]) => (
                          <>
                            <TableHead key={buName}>
                              <TableRow>
                                <StyledTableCell>{buName}</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {buData?.map((r, index) => (
                                <TableRow key={index}>
                                  <StyledTableCell sx={{ width: "34%" }}>
                                    {" "}
                                    {r?.businesUnitsiteName}

                                    {buData[index]?.siteDocuments?.find((q) => q?.businessUnitSiteId == r?.clientBusinessUnitSiteID) ? (<>
                                      {buData[index]?.siteDocuments?.map(
                                        (documentItem, documentIndex) => (
                                          <>
                                            <TableRow
                                              key={`${buName}_document_${documentIndex}`}
                                            >
                                              <a
                                                style={{
                                                  textDecoration: "none",
                                                  color: "#2A93DB",
                                                  cursor: "pointer",
                                                }}
                                                className="mt-3"
                                                key={documentIndex}
                                                onClick={() => handleDownload(documentItem)}
                                              >
                                                <i
                                                  className="fa fa-cloud-download"
                                                  aria-hidden="true"
                                                ></i>
                                                {documentItem?.documentName}
                                              </a>
                                            </TableRow>
                                          </>)
                                      )}
                                    </>) : ""}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ width: "32%" }}>
                                    <span sx={{ fontSize: "20px" }}>
                                      {r?.comment}
                                    </span>
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ width: "30%" }}>
                                    <StatusComponent type={r?.pqSiteStatus} />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() => handleClickOpen(2, r)}
                                      hidden={getOrgType() == "Client" ? true : getOrgType() == "Vendor" && IsMultiple == true ? !(IsmultipleClientEddbuttionShow?.includes(PqStatusID)) : (getOrgType() == "Vendor" && NotDisPqStatusListForEditandAdd?.includes(PqStatusID))}
                                    >
                                      <img
                                        src={Edit}
                                        alt="editicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ width: "30%" }}>
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        Deletedialogbox(r?.prequalificationSitesId)
                                      }
                                      hidden={getOrgType() == "Client" ? true : (getOrgType() == "Vendor" && IsMultiple == true && r?.prequalificationSitesId == 3) ? true : (getOrgType() == "Vendor" && NotDisPqStatusListForDelete?.includes(PqStatusID))}
                                    >
                                      <img
                                        src={Trash}
                                        alt="trashicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>
                                  </StyledTableCell>
                                </TableRow>
                              ))}
                            </TableBody>

                            {buData[0]?.documents?.length > 0 && (
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell>{`Download Documents for ${buName}`}</StyledTableCell>
                                  <StyledTableCell>&nbsp;</StyledTableCell>
                                  <StyledTableCell>&nbsp;</StyledTableCell>
                                  <StyledTableCell>&nbsp;</StyledTableCell>
                                  <StyledTableCell>&nbsp;</StyledTableCell>
                                </TableRow>
                              </TableHead>
                            )}
                            <TableBody>
                              {buData[0]?.documents?.map(
                                (documentItem, documentIndex) => (
                                  <TableRow
                                    key={`${buName}_document_${documentIndex}`}
                                  >
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        color: "#2A93DB",
                                        cursor: "pointer",
                                      }}
                                      className="mx-3"
                                      key={documentIndex}
                                      onClick={() => handleDownload(documentItem)}
                                    >
                                      <i
                                        className="fa fa-cloud-download"
                                        aria-hidden="true"
                                      ></i>
                                      {documentItem?.documentName}
                                    </a>
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </>
                        ))}
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          </>
        ))
      ) : loading ? (
        <LoadingSpinner />
      ) : (
        <Nodata />
      )}

      <div className="mt-5" hidden={!(IMPORTANTNOTICECLIENTIDS?.includes(PQCLIENTID))}>
        <span className="text-danger mx-3 mt-5" style={{ fontWeight: "bold" }}>
          IMPORTANT NOTICE
          <br />
          <span className="mx-3 mt-5">  All contractor employees must complete the {PqClientName} safety orientation and pass a quiz before being allowed to work onsite.</span> <br />
          <span className="mx-3 mt-2">  Specific information can be found in the Prequalification Requirements section.</span>
        </span>
      </div>
    </Card>
  );
}
